module.exports = __webpack_public_path__ + "assets/img/about-us.3f6c71ab.jpg";